import * as actions from './actions';
import * as selectors from './selectors';
import { actions as filterActions } from './../filters';
import { TESTS_PAGE_STATUSES } from '../../constants';

import { operations } from './index';

export const getTestCases = (options) => (dispatch, getState) => {
  const payload = options || selectors.statusSelector(getState());
  const params = selectors.testCasesParamsSelector(getState(), payload);
  return dispatch(actions.getTestCases(params, payload));
};

export const getTestNamesByFilter = (key) => (dispatch) => {
  const { path, status } = TESTS_PAGE_STATUSES[key];
  dispatch(filterActions.pushPath(path));
  return dispatch(operations.getTestCases({ status }));
};
